/* Relatórios: relatório GHG em tela e exportações em CSV. */

import { isApi } from '../../core/config';
import { cat, state } from '../../core/estado';
import { esc } from '../../core/formato';
import { ic } from '../../ui/dom';
import { ir } from '../../roteador';
import type { Pagina } from '../pagina';
import { exportarCategorias, exportarLancamentos, exportarMateriais, exportarMensal, exportarObras } from './exportacoes';

interface Relatorio {
  nome: string;
  formato: 'Tela' | 'CSV';
  descricao: () => string;
  icone: string;
  acao: string;
}

const RELATORIOS: Relatorio[] = [
  { nome: 'Relatório GHG Protocol', formato: 'Tela', icone: 'i-target', acao: 'ghg', descricao: () => 'Emissões por gás e por escopo, CO₂ biogênico e tabelas por categoria — no formato do Programa Brasileiro GHG Protocol.' },
  { nome: 'Emissões por mês e por escopo', formato: 'CSV', icone: 'i-calc', acao: 'mensal', descricao: () => `Tabela mensal do ano ${esc(state.f.ano)}, pronta para o time de engenharia e obras.` },
  { nome: 'Emissões por obra', formato: 'CSV', icone: 'i-building', acao: 'obras', descricao: () => 'Totais de escopo 1, 2 e 3 por obra no ano selecionado.' },
  { nome: 'Emissões por categoria', formato: 'CSV', icone: 'i-target', acao: 'categorias', descricao: () => 'Total de cada categoria de emissão e número de lançamentos no ano.' },
  { nome: 'Materiais comprados', formato: 'CSV', icone: 'i-calc', acao: 'materiais', descricao: () => 'Bens e serviços comprados por material: quantidade, valor e tCO₂e.' },
  { nome: 'Todos os lançamentos', formato: 'CSV', icone: 'i-doc', acao: 'lancamentos', descricao: () => 'Cada lançamento do ano com data, obra, categoria, fornecedor e emissões por gás — para auditoria.' },
];

export const listaRelatorios: Pagina = {
  render: () => `<h1 class="page">Relatórios</h1>
  <p class="sub">Relatórios gerados a partir do inventário ${isApi() ? `de ${esc(cat().empresa.nome)}` : 'de demonstração'}, com os valores calculados pela ZNIT.</p>
  <div class="grid g3">${RELATORIOS.map((r) => `<div class="rep-card">
    <div class="tile-ic">${ic(r.icone)}</div>
    <h3>${r.nome}</h3><p>${r.descricao()}</p>
    <div class="between" style="margin-top:auto"><span class="pill grey">${r.formato}</span>
      <button class="btn btn-ghost" data-clique="${r.acao}">${ic(r.formato === 'Tela' ? 'i-chev-r' : 'i-dl')} ${r.formato === 'Tela' ? 'Abrir' : 'Baixar'}</button></div>
  </div>`).join('')}</div>`,

  acoes: {
    ghg: () => ir('#/relatorios/ghg'),
    mensal: () => exportarMensal(),
    obras: () => exportarObras(),
    categorias: () => exportarCategorias(),
    materiais: () => exportarMateriais(),
    lancamentos: () => exportarLancamentos(),
  },
};
